import { useQuery } from '@tanstack/react-query'
import { assignmentsApi } from '@/api/endpoints/assignments'

export function useAssignments(sku: string) {
  return useQuery({
    queryKey: ['products', sku, 'assignments'],
    queryFn: () => assignmentsApi.list(sku),
    select: (data) => data.items,
    enabled: !!sku,
  })
}
